import { SAMPLE_HEADSHOT_SRC } from './emailImages';
// Signature block shared by all notification emails. Sending fills in the person's own profile details.
export const signatureHtml = (p) => `<table role="presentation" cellpadding="0" cellspacing="0" style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.4;color:#222222;margin-top:8px;">
  <tr>
    <td style="padding-right:16px;vertical-align:top;"><img src="${SAMPLE_HEADSHOT_SRC}" alt="{{${p}_first_name}} {{${p}_last_name}}" width="96" style="width:96px;height:auto;border-radius:6px;display:block;"></td>
    <td style="vertical-align:top;">
      <div style="font-weight:bold;font-size:16px;">{{${p}_first_name}} {{${p}_last_name}}</div>
      <div>{{${p}_title}}</div>
      <div>RESIDENCE | eXp Realty</div>
      <div>{{${p}_phone}}</div>
      <div><a href="mailto:{{${p}_email}}" style="color:#8C6D1F;">{{${p}_email}}</a></div>
    </td>
  </tr>
</table>`;

export const AGENT_SIGNATURE_HTML = signatureHtml('agent');
export const SENDER_SIGNATURE_HTML = signatureHtml('sender');
